module.exports = __webpack_public_path__ + "static/img/mobile-web-sub-02.8c1d53e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/mobile-web-sub-02.png
// module id = c7CC
// module chunks = 0